<ng-container *defineVariable="mobileService.mobileState$ | async as mobileState">
  @if (preferences) {
    <h3
      class="fw-normal"
        [ngClass]="{
            'd-inline font-13': !mobileState.mobile && !isDeeplink,
            'text-center': mobileState.mobile && !isDeeplink,
        }"
      >
      {{ preferences.shopName }}
      <span class="px-2 font-08" [ngClass]="{ 'd-none': !env.showVersion }">v{{ version }}</span>
    </h3>
  }
</ng-container>
